<div class="row">
  <div class="col" style="text-align: center;">
    <label>Temp Route</label>
  </div>
</div>
<div *ngIf="!is_data_available">
  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</div>
<div class="row" *ngIf="is_data_available">
  <div class="col">
    <div class="row">
      <div class="col">Route name : {{route_and_business_details['main_route_details']['route_name']}}</div>
      <div class="col-4"
        [ngClass]="route_and_business_details['main_route_details']['tray_count'] > route_and_business_details['defalut_tray_capacity'] ? 'greater_count' : 'lesser_count'">
        Tray count : {{route_and_business_details['main_route_details']['tray_count']}} </div>
    </div>
    <div class="row" style="text-align: center;">
      <div class="col-2">Code</div>
      <div class="col-4">Name</div>
      <div class="col-3">Tray count</div>
      <div class="col-3">Move </div>
    </div>
    <div class="row" style="overflow: auto; height: 500px; border: 1px solid black; padding: 10px;">
      <div class="col">
        <mat-card
          *ngFor="let business of route_and_business_details['main_route_details']['business_details']; let business_index=index"
          style="margin-bottom: 10px;">
          <div class="row">
            <div class="col-2">{{business['business_code']}} </div>
            <div class="col-5">{{business['agent_first_name']}} {{business['agent_last_name']}}</div>
            <div class="col-2">{{business['tray_count']}} </div>
            <div class="col-3" style="text-align: right;">
              <button [disabled]="is_route_closed['main_route']['is_closed']"
                (click)="moveBusinessToTempRoute(business['business_id'], business_index)">
                <i class="material-icons">trending_flat</i>
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="col-1"></div>
  <div class="col">
    <div class="row">
      <div class="col">Route name : {{route_and_business_details['temp_route_details']['route_name']}}</div>
      <div class="col-4">Tray count : {{route_and_business_details['temp_route_details']['tray_count']}} </div>
    </div>
    <div class="row" style="text-align: center;">
      <div class="col-2">Code</div>
      <div class="col-4">Name</div>
      <div class="col-3">Tray count</div>
      <div class="col-3">Move </div>
    </div>
    <div class="row" style="overflow: auto; height: 500px; border: 1px solid black; padding: 10px;">
      <div class="col">
        <mat-card
          *ngFor="let business of route_and_business_details['temp_route_details']['business_details'] ;let business_index=index"
          style="margin-bottom: 10px;">
          <div class="row">
            <div class="col-2">{{business['business_code']}} </div>
            <div class="col-5">{{business['agent_first_name']}} {{business['agent_last_name']}}</div>
            <div class="col-2">{{business['tray_count']}} </div>
            <div class="col-3" style="text-align: right;">
              <button [disabled]="is_route_closed['main_route']['is_closed']"
                (click)="moveBusinessToMainRoute(business['business_id'], business_index)">
                <span class="material-icons">
                  keyboard_backspace
                </span>
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<br>
<div *ngIf="is_data_available">
  <div class="row">
    <div class="col" style="text-align: center; margin-left: 25%;">
      <button mat-button
        (click)="closeRouteClicked(route_and_business_details['main_route_details']['route_id'], 'main')"
        style="background: green;color: white;"> Finalize &
        Close Route</button>
    </div>
    <div class="col-3" style="text-align: right;">
      <button mat-button (click)="closeClicked()" style="background: red;color: white;">Close</button>
    </div>
    <!-- <div class="col" style="text-align: right;">
      <button mat-button
        (click)="closeRouteClicked(route_and_business_details['temp_route_details']['route_id'], 'temp')"
        style="background: green;color: white;"
        [disabled]="route_and_business_details['temp_route_details']['business_details'].length == 0|| is_route_closed['temp_route']['is_closed']">Close
        route</button>
    </div> -->
  </div>
</div>
